import {getQuery, isEmpty} from "../../tools/utils";
import API from '@/apis/index';
const formSet = {
    formSet: {form_class: 'base_form',  body: [
            {index: 1, body_class: 'q-gutter-sm row items-start',
                items:[
                    {index: 1, label: '特价单号', name: 'tjdh',value: 'TJDH20250224001',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '价单号/销售订单号', name: 'VBELN',value: '001',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '销售组织', name: 'VKORG',value: '销售一部',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '销售渠道', name: 'VTWEG',value: '网上销售',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '销售产品组', name: 'SPART',value: '',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '创建人', name: 'ERNAM',value: '王子豪',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '创建时间', name: 'ERZET',value: '2025-02-24 16:32:00',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '报价日期', name: 'ERDAT',value: '2025-02-24 17:12:00',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '订货人', name: 'KUNNR',value: '老刘',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '收货人', name: 'KGNNR',value: '李明',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '收货人地址名称1', name: 'NAME1',value: '河北省保定市莲池区',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '收货人地址名称2', name: 'NAME2',value: '',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '收货人邮政编码', name: 'POSTL_COD1',value: '071000',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '收货人城市', name: 'CITY1',value: '保定',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '三方协议号', name: 'ZZPROM',value: 'XYH20250224001',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '特折号', name: 'BSTKD',value: 'TZH20250224001',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '订单/报价单类型', name: 'AUART',value: '',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '销售订单货币单位', name: 'WAERK',value: '人民币',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '预付款标志', name: 'DPFLAG',value: '0',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '项目信息', name: 'ITEM_DATA',value: '',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                ]
            },
        ]},
    formSet2: {form_class: 'base_form',  body: [
            {index: 1, body_class: 'q-gutter-sm row items-start',
                items:[
                    {index: 1, label: '整单不含税金额', name: 'NETWRH',value: '',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '整单税额', name: 'MWSTH',value: '',labelWidth:130, showlabel: true, type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                ]
            },
        ]}
};
const baseData = {
    baseData:{
        company: {selected: '', data: []}, //公司
        payment: {selected: '', data: []}, //付款方式
        address: {selected: '', data: []}, // 收货地址
        branch: {selected: '', data: []}, // 行业
        country: {selected: '', data: []}, // 行业
        form: {},
        showQuery: true,
    }
};
const tableSet = {
    tableSet:{
        table_class: 'layout-table',
        dense: true,
        edit: false,
        row_key:'FEntryId',
        isFullscreen:false,
        hidePagination: true,
        isSelect:true,
        selected: [],
        selection: 'multiple',
        separator: 'cell', //表格边框
        data:[
        ],
        columns: [
            {name: 'POSNR',field: 'POSNR',label: '特价单行号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'UEPOS',field: 'UEPOS',label: '高阶行号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'MATNR',field: 'MATNR',label: '订货号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'KWMENG',field: 'KWMENG',label: '数量',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            {name: 'VRKME',field: 'VRKME',label: '数量单位',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'EDATU',field: 'EDATU',label: '客户期望交货日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CDATE',field: 'CDATE',label: '承诺日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'MWSTI',field: 'MWSTI',label: '税额',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            {name: 'NETWRI',field: 'NETWRI',label: '不含税金额',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            {name: 'WAERK_I',field: 'WAERK_I',label: '销售订单行货币单位',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'WERKS',field: 'WERKS',label: '出货物流中心',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'ZZCRDDATE',field: 'ZZCRDDATE',label: '客户要求货期（原始）',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'KGNNR_I',field: 'KGNNR_I',label: '行项目收货人',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'NAME1_I',field: 'NAME1_I',label: '行项目收货人地址名称1',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'NAME2_I',field: 'NAME2_I',label: '行项目收货人地址名称2',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'POSTL_COD1_I',field: 'POSTL_COD1_I',label: '行项目收货人邮政编码',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CITY1_I',field: 'CITY1_I',label: '行项目收货人城市',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CUSTOMIZED_LABEL',field: 'CUSTOMIZED_LABEL',label: '打标信息',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'ITEM_PRICING',field: 'ITEM_PRICING',label: '价格条件信息',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
        ],
        visibleColumns: [],
        tools: {
            isShow:true,
            active_index: 1,
        }
    }
}
const state = () => ({
    specialOfferDetails: Object.assign({}, formSet,baseData,tableSet)
})
const getters = {
    getFormSet: state => state.specialOfferDetails.formSet,
    getFormSet2: state => state.specialOfferDetails.formSet2,
    getBaseData :state => state.specialOfferDetails.baseData,
    getTableSet:state => state.specialOfferDetails.tableSet
}
const mutations = {
    ['addRow'](state, data) {
        state.specialOfferDetails.tableSet.data.push(data);
        state.specialOfferDetails.tableSet.data.forEach((item, index) => {
            item.FEntryId = (index + 1);
        })
    },
    ['refreshTableHeight'](state, data) {
        state.specialOfferDetails.tableSet.height = data + 'px';
    },
    ['clearData'](state,data){
        state.specialOfferDetails.formSet.billObj = {};
        state.specialOfferDetails.tableSet.data = [];
        state.specialOfferDetails.formSet.body[0].items.forEach(item=>{
            item.value = '';
        });
    },
    ['setHeader'](state,data){
        state.specialOfferDetails.formSet.billObj = data;
        state.specialOfferDetails.formSet.body[0].items.forEach(item=>{
            item.value = data[item.name];
        });
    },
    ['setList'](state,data){
        state.specialOfferDetails.tableSet.data = data;
    },
};
const actions = {
    ['getHeader']({state,commit,rootGetters,dispatch},data){
        if(state.specialOfferDetails.formSet.loading) return
        state.specialOfferDetails.formSet.loading = true;
        state.specialOfferDetails.tableSet.loading = true;
        return new Promise((resolve, reject)=>{
            API.quotationHeaderGet(data).then((data)=>{
                if(data.status == 200){
                    commit('setHeader',data.data);
                    resolve(data.data);
                }else{
                    state.specialOfferDetails.formSet.loading = false;
                    state.specialOfferDetails.tableSet.loading = false;
                    reject();
                }
            }).catch((error)=>{
                state.specialOfferDetails.formSet.loading = false;
                state.specialOfferDetails.tableSet.loading = false;
                dispatch("response/set-api-response", {...error,errorMessage:'获取单据头失败!'}, { root: true });
                reject()
            })
        })
    },
    ['getList']({state,commit,dispatch},data){
        return new Promise((resolve, reject)=>{
            let obj = {
                FQuotation:data.id
            }
            let query = getQuery(obj);
            API.quotationListGet(query).then((data)=>{
                state.specialOfferDetails.formSet.loading = false;
                state.specialOfferDetails.tableSet.loading = false;
                if(data.status == 200){
                    commit('setList',data.data.results);
                    resolve(data.data)
                }else{
                    reject();
                }
            }).catch((error)=>{
                state.specialOfferDetails.formSet.loading = false;
                state.specialOfferDetails.tableSet.loading = false;
                dispatch("response/set-api-response", {...error,errorMessage:'获取单据体失败!'}, { root: true });
                reject()
            })
        })
    },
    ['confirmationOk']({state,commit,dispatch},data){
        if(state.specialOfferDetails.formSet.loading) return;
        let params ={};
        state.specialOfferDetails.formSet.body[0].items.forEach(item=>{
            if(['FNotes','FConsignee','FDate','FConsigneePhone','FDeliveryAddress','FSalesman'].includes(item.name)){
                params[item.name] = item.value;
            }
        });
        params.FCustomer = state.specialOfferDetails.formSet.billObj.FCustomer;
        params.id = state.specialOfferDetails.formSet.billObj.id;
        state.specialOfferDetails.formSet.loading = true;
        state.specialOfferDetails.tableSet.loading = true;
        return new Promise((resolve, reject)=>{
            API.confirmationSave(params).then((data)=>{
                state.specialOfferDetails.formSet.loading = false;
                state.specialOfferDetails.tableSet.loading = false;
                if(data.status == 200){
                    resolve(data.data);
                }else{
                    reject(data);
                }
            }).catch((e)=>{
                state.specialOfferDetails.formSet.loading = false;
                state.specialOfferDetails.tableSet.loading = false;
                dispatch("response/set-api-response", {...e,errorMessage:'确认失败!'}, { root: true });
                reject(e);
            })
        })
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
